/* eslint-disable */
export default {
  logging: 'Connessione...',
  logCall: 'Registra chiamata',
  editLog: 'Modifica registro',
  select: 'Selez. record',
  OnHold: 'In attesa',
  Ringing: 'Chiamata in arrivo',
  CallConnected: 'Chiamata connessa',
  unknownUser: 'Utente sconosciuto',
  unknownNumber: 'Numero anonimo',
  unavailable: 'Non disponibile',
  viewDetails: 'Visualizza dettagli',
  conferenceCall: 'Conferenza telefonica',
  callerId: 'ID chiamante',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"callerId"@#@ @source: @#@"Caller ID"@#@
